import { Component } from '@angular/core';
import { AbstractInputComponent } from '../abstract-input.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationErrorsComponent } from '../validation-errors/validation-errors.component';
@Component({
  selector: 'common-empty-input',
  standalone: true,
  imports: [CommonModule, TranslateModule, ValidationErrorsComponent],
  templateUrl: './empty-input.component.html',
  styleUrls: ['./empty-input.component.scss'],
})
export class EmptyInputComponent extends AbstractInputComponent {}
